import Component1 from './1';
import Component2 from './2';
import Component3 from './3';
import Component4 from './4';
import Component5 from './5';

export default {
  'NAVBAR_SEARCH_1': Component1,
  'NAVBAR_SEARCH_2': Component2,
  'NAVBAR_SEARCH_3': Component3,
  'NAVBAR_SEARCH_4': Component4,
  'NAVBAR_SEARCH_5': Component5,
}
